// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.users-page {
  padding: 2rem;
  max-width: 1400px;
  margin: 0 auto;
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}

.page-header h1 {
  margin: 0;
  font-size: 1.8rem;
  color: #333;
}

.btn-primary {
  padding: 0.7rem 1.5rem;
  background: var(--button-color, #007bff);
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: background 0.2s;
}

.btn-primary:hover {
  background: var(--hover-color, #0056b3);
}

.btn-secondary {
  padding: 0.7rem 1.5rem;
  background: white;
  color: #666;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s;
}

.btn-secondary:hover {
  background: #f5f5f5;
  border-color: #bbb;
}

.form-card {
  background: white;
  border-radius: 8px;
  padding: 2rem;
  margin-bottom: 2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.form-card h2 {
  margin: 0 0 1.5rem 0;
  font-size: 1.5rem;
  color: #333;
}

.form-group {
  margin-bottom: 1rem;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: #555;
  font-size: 0.9rem;
}

.form-group input,
.form-group select {
  width: 100%;
  padding: 0.7rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 0.95rem;
  color: #333;
  background: white;
}

.form-group input:focus,
.form-group select:focus {
  outline: none;
  border-color: var(--button-color, #007bff);
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 2rem;
  padding-top: 1.5rem;
  border-top: 1px solid #f0f0f0;
}

.error-message {
  background: #f8d7da;
  color: #721c24;
  padding: 1rem;
  border-radius: 4px;
  margin-bottom: 1rem;
}

.users-table-container {
  background: white;
  border-radius: 8px;
  padding: 1.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow-x: auto;
}

.users-table {
  width: 100%;
  border-collapse: collapse;
}

.users-table thead {
  background: #f8f9fa;
}

.users-table th {
  padding: 1rem;
  text-align: left;
  font-weight: 600;
  color: #555;
  border-bottom: 2px solid #e9ecef;
}

.users-table td {
  padding: 1rem;
  border-bottom: 1px solid #e9ecef;
}

.users-table tbody tr:hover {
  background: #f8f9fa;
}

.role-badge {
  padding: 0.3rem 0.8rem;
  border-radius: 12px;
  font-size: 0.85rem;
  font-weight: 500;
}

.role-badge.admin {
  background: #e3f2fd;
  color: #1976d2;
}

.role-badge.user {
  background: #f3e5f5;
  color: #7b1fa2;
}

.actions {
  display: flex;
  gap: 0.5rem;
}

.btn-edit {
  padding: 0.4rem 0.8rem;
  background: white;
  color: #007bff;
  border: 1px solid #007bff;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.85rem;
  transition: all 0.2s;
}

.btn-edit:hover {
  background: #007bff;
  color: white;
}

.btn-delete {
  padding: 0.4rem 0.8rem;
  background: white;
  color: #dc3545;
  border: 1px solid #dc3545;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.85rem;
  transition: all 0.2s;
}

.btn-delete:hover {
  background: #dc3545;
  color: white;
}

@media (max-width: 768px) {
  .users-page {
    padding: 1rem;
  }

  .users-table-container {
    padding: 1rem;
  }

  .users-table {
    font-size: 0.9rem;
  }

  .users-table th,
  .users-table td {
    padding: 0.7rem 0.5rem;
  }

  .actions {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/UsersPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,wCAAwC;EACxC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;;IAEE,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".users-page {\n  padding: 2rem;\n  max-width: 1400px;\n  margin: 0 auto;\n}\n\n.page-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2rem;\n}\n\n.page-header h1 {\n  margin: 0;\n  font-size: 1.8rem;\n  color: #333;\n}\n\n.btn-primary {\n  padding: 0.7rem 1.5rem;\n  background: var(--button-color, #007bff);\n  color: white;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: background 0.2s;\n}\n\n.btn-primary:hover {\n  background: var(--hover-color, #0056b3);\n}\n\n.btn-secondary {\n  padding: 0.7rem 1.5rem;\n  background: white;\n  color: #666;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: all 0.2s;\n}\n\n.btn-secondary:hover {\n  background: #f5f5f5;\n  border-color: #bbb;\n}\n\n.form-card {\n  background: white;\n  border-radius: 8px;\n  padding: 2rem;\n  margin-bottom: 2rem;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.form-card h2 {\n  margin: 0 0 1.5rem 0;\n  font-size: 1.5rem;\n  color: #333;\n}\n\n.form-group {\n  margin-bottom: 1rem;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  color: #555;\n  font-size: 0.9rem;\n}\n\n.form-group input,\n.form-group select {\n  width: 100%;\n  padding: 0.7rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 0.95rem;\n  color: #333;\n  background: white;\n}\n\n.form-group input:focus,\n.form-group select:focus {\n  outline: none;\n  border-color: var(--button-color, #007bff);\n}\n\n.form-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 1rem;\n  margin-top: 2rem;\n  padding-top: 1.5rem;\n  border-top: 1px solid #f0f0f0;\n}\n\n.error-message {\n  background: #f8d7da;\n  color: #721c24;\n  padding: 1rem;\n  border-radius: 4px;\n  margin-bottom: 1rem;\n}\n\n.users-table-container {\n  background: white;\n  border-radius: 8px;\n  padding: 1.5rem;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  overflow-x: auto;\n}\n\n.users-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.users-table thead {\n  background: #f8f9fa;\n}\n\n.users-table th {\n  padding: 1rem;\n  text-align: left;\n  font-weight: 600;\n  color: #555;\n  border-bottom: 2px solid #e9ecef;\n}\n\n.users-table td {\n  padding: 1rem;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.users-table tbody tr:hover {\n  background: #f8f9fa;\n}\n\n.role-badge {\n  padding: 0.3rem 0.8rem;\n  border-radius: 12px;\n  font-size: 0.85rem;\n  font-weight: 500;\n}\n\n.role-badge.admin {\n  background: #e3f2fd;\n  color: #1976d2;\n}\n\n.role-badge.user {\n  background: #f3e5f5;\n  color: #7b1fa2;\n}\n\n.actions {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.btn-edit {\n  padding: 0.4rem 0.8rem;\n  background: white;\n  color: #007bff;\n  border: 1px solid #007bff;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.85rem;\n  transition: all 0.2s;\n}\n\n.btn-edit:hover {\n  background: #007bff;\n  color: white;\n}\n\n.btn-delete {\n  padding: 0.4rem 0.8rem;\n  background: white;\n  color: #dc3545;\n  border: 1px solid #dc3545;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.85rem;\n  transition: all 0.2s;\n}\n\n.btn-delete:hover {\n  background: #dc3545;\n  color: white;\n}\n\n@media (max-width: 768px) {\n  .users-page {\n    padding: 1rem;\n  }\n\n  .users-table-container {\n    padding: 1rem;\n  }\n\n  .users-table {\n    font-size: 0.9rem;\n  }\n\n  .users-table th,\n  .users-table td {\n    padding: 0.7rem 0.5rem;\n  }\n\n  .actions {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
